import common from './common.json';
import auth from './auth.json';
import dashboard from './dashboard.json';
import notes from './notes.json';
import admin from './admin.json';
import messages from './messages.json';

export default {
  common,
  auth,
  dashboard,
  notes,
  admin,
  messages
};